import { FC } from 'react';
import { Box, styled, Typography, useTheme } from '@mui/material';
import { IconProps } from '@phosphor-icons/react';
import { Button } from '@alterdomus-analytics/dna-ui';

const IconWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.custom.palette.accentBackground,
  borderRadius: '100%',
  width: theme.spacing(19),
  height: theme.spacing(19)
}));

export const ErrorMessage: FC<{
  error: string;
  Icon: React.ForwardRefExoticComponent<IconProps & React.RefAttributes<SVGSVGElement>>;
  message?: string;
  action?: {
    text: string;
    onClick: () => void;
  };
}> = ({ error, Icon, message, action }) => {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
      <IconWrapper
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ marginBottom: '40px' }}
      >
        <Icon size={80} color={theme.palette.info.dark} />
      </IconWrapper>
      <Typography align="center" variant="h1" sx={{ marginBottom: '32px' }}>
        {error}
      </Typography>
      {message && (
        <Typography align="center" variant="h3" sx={{ marginBottom: '24px' }}>
          {message}
        </Typography>
      )}
      {action && (
        <Button
          variant="primary"
          sx={{
            '&.MuiButton-root': {
              height: '40px',
              padding: '10px 20px',
              letterSpacing: 'normal'
            }
          }}
          onClick={() => action.onClick()}
          type="submit"
        >
          {action.text}
        </Button>
      )}
    </Box>
  );
};
